/**
 * Cliente better-auth para admin/facilitador.
 *
 * O bearer plugin do servidor retorna o session-token no header
 * `set-auth-token` após signIn bem-sucedido.
 * O createAuthClient armazena-o internamente; aqui nós também o
 * salvamos em sessionStorage para injeção no adminAxios (Bearer header).
 *
 * Sessão configurada no servidor:
 *   expiresIn  = 8 h
 *   updateAge  = 60 s  → renova automaticamente a cada 1 minuto
 *   cookieCache.maxAge = 60 s
 */
import { createAuthClient } from 'better-auth/react'

// Usa a própria origem da página por padrão — evita cross-origin para um host
// cujo certificado TLS não corresponde ao nome acessado pelo usuário.
const BASE_URL = import.meta.env.VITE_API_URL || window.location.origin

export const authClient = createAuthClient({
  baseURL: `${BASE_URL}/api/bauth`,

  fetchOptions: {
    // Captura o header set-auth-token após cada resposta
    onSuccess(context) {
      const token = context.response.headers.get('set-auth-token')
      if (token) {
        sessionStorage.setItem('baToken', token)
      }
    },
  },
})

export const { signIn, signOut, useSession } = authClient
